<template>
  <div>
    <el-dialog title="累计收益"
               :visible.sync="dialogFormVisible"
               @close="emitClose"
               @open="handleOpen()"
               :close-on-click-modal="false"
               width="1180px">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">
        <el-form-item label="统计时间">
          <el-date-picker class="datetime"
                          v-model="createDatetime"
                          type="datetimerange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          @change="getList(true)"
                          :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </el-form-item>

      </el-form>
      <el-table :data="results"
                border
                style="width: 100%"
                size="mini">
        <el-table-column prop="ref_id"
                         label="订单ID"
                         width="80"
                         align="center">
        </el-table-column>
        <el-table-column label="商品类型"
                         width="100"
                         align="center">
          <template slot-scope="scope">
            <span>{{ handleRender(scope.row.ref_type, 'productType') }}</span>
          </template>
        </el-table-column>
        <el-table-column label="商品名称"
                         align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <div style="text-align:left;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">{{ scope.row.goods_name }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="user_nickname"
                         label="购买用户"
                         width="100"
                         align="center">
        </el-table-column>
        <el-table-column label="基础课时费(元)"
                         width="110"
                         align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.ref_senior_order_salary_amount }}元</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="结算周期"
                           width="110"
                           align="center">
            <template slot-scope="scope">
              <span v-if="scope.row."></span> -->
        <!-- <span>{{ scope.row.ref_senior_order_salary_amount }}元</span> -->
        <!-- </template>
          </el-table-column> -->
        <el-table-column label="结课奖励(元)"
                         width="110"
                         align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.ref_senior_order_bonus_amount }}元</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="订单金额(元)"
                           width="100"
                           align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.amount }}元</span>
            </template>
          </el-table-column> -->
        <el-table-column label="订单状态"
                         width="80"
                         align="center">
          <template slot-scope="scope">
            <span>{{ statusRender(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付时间"
                         width="140"
                         align="center">
          <template slot-scope="scope">
            <span>{{  $moment(scope.row.create_time).format('YYYY-MM-DD HH:mm')  }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单收益"
                         width="100"
                         align="center">
          <template slot-scope="scope">
            <span>{{scope.row.type==2?'-':''}}{{ scope.row.amount }}元</span>
          </template>
        </el-table-column>
        <el-table-column label="收益类型"
                         width="100"
                         align="center">
          <template slot-scope="scope">
            <!--     {{scope.row.parent_level==0?'推广佣金':'邀请奖励'}} -->
            <span>{{ handleRender(scope.row.parent_level, 'parentLevel') }}</span>
          </template>
        </el-table-column>
        <el-table-column label="结算状态"
                         width="100"
                         align="center">
          <template slot-scope="scope">
            <el-tag type="danger"
                    size="mini"
                    v-if="scope.row.status==0">待结算</el-tag>
            <el-tag size="mini"
                    v-if="scope.row.status==1">已结算</el-tag>
            <el-tag type="info"
                    size="mini"
                    v-if="scope.row.status==2">已撤销</el-tag>
            <el-tag type="success"
                    size="mini"
                    v-if="scope.row.status==3">已提现</el-tag>
            <el-tag type="warning"
                    size="mini"
                    v-if="scope.row.status==4">提现中</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <div class="footer-wrap">
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>

      <div class="footer">
        <el-button @click="emitClose(false)">取消</el-button>
        <el-button type="primary"
                   @click="submit('formRules')">确定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { profitlogsList } from '@/api/senior'
export default {
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    rowId: {
      type: Number,
      default: () => {
        return null
      },
    },
  },
  data() {
    return {
      dialogFormVisible: this.visible,
      query: {
        pageIndex: 1,
        pageSize: 10,
      },
      results: [],
      pageTotal: 0,
      createDatetime: '',
    }
  },
  mounted() {},
  watch: {
    visible(val) {
      this.dialogFormVisible = val
    },
    // 时间数据监听
    createDatetime(value) {
      if (value) {
        this.query.log_statistic_start_time = this.$moment(value[0]).valueOf()
        this.query.log_statistic_end_time = this.$moment(value[1]).valueOf()
      } else {
        this.query.log_statistic_start_time = ''
        this.query.log_statistic_end_time = ''
      }
    },
  },

  methods: {
    handleOpen() {
      this.getList()
    },
    emitClose() {
      this.$emit('close')
    },
    getList(reset) {
      if (reset) {
        this.query.pageIndex = 1
      }
      this.query.uid = this.rowId
      profitlogsList(this.query).then((res) => {
        this.results = res.list || []
        this.pageTotal = res.count
      })
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      this.getList()
    },
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.getList()
    },
    handleRender(value, type) {
      let productTypes = {
        1: '课程',
        2: '题库',
        3: '专栏',
        4: '资料',
        5: '文章',
        6: '学长',
        7: '联报',
        8: '课酬',
      }
      let status = {
        0: '待结算',
        1: '已结算',
        2: '已退款',
        3: '已提现',
        4: '提现中',
      }
      let payTypes = {
        1: '支付宝',
        2: '微信',
      }
      let parentLevel = {
        0: '推广佣金',
        1: '邀请奖励',
        200: '创作收益',
        201: '课时课酬',
      }
      if (type == 'productType') {
        return productTypes[value] || ''
      } else if (type == 'status') {
        return status[value] || ''
      } else if (type == 'payType') {
        return payTypes[value] || ''
      } else if (type == 'parentLevel') {
        return parentLevel[value] || ''
      }
      return ''
    },
    // 订单状态渲染
    statusRender(row) {
      const order_status = {
        0: '待支付',
        1: '已支付',
        2: '待发货',
        3: '待收货',
        4: '已完成',
        5: '已取消',
      }
      return order_status[row.order_status] || ''
    },
  },
}
</script>

<style lang="less" scoped>
.input-wrap {
  display: flex;
  .el-input {
    margin-right: 16px;
  }
}
.footer-wrap {
  margin-top: 10px;
  display: flex;
  justify-content: center;
}
.footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>